module.exports = __webpack_public_path__ + "img/chatzotzra_no.ef3e040a.png";